var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormulaIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M5,7C4.47,7 3.961,7.211 3.586,7.586C3.211,7.961 3,8.47 3,9V15C3,15.53 3.211,16.039 3.586,16.414C3.961,16.789 4.47,17 5,17H8V15H5V9H8V7H5ZM11,7C10.47,7 9.961,7.211 9.586,7.586C9.211,7.961 9,8.47 9,9V15C9,15.53 9.211,16.039 9.586,16.414C9.961,16.789 10.47,17 11,17H13C13.53,17 14.039,16.789 14.414,16.414C14.789,16.039 15,15.53 15,15V9C15,8.47 14.789,7.961 14.414,7.586C14.039,7.211 13.53,7 13,7H11ZM11,9H13V15H11V9ZM16,10.5V12H19V13.5H17.5C17.102,13.5 16.721,13.658 16.439,13.939C16.158,14.221 16,14.602 16,15V18H20.5V16.5H17.5V15H19C19.398,15 19.779,14.842 20.061,14.561C20.342,14.279 20.5,13.898 20.5,13.5V12C20.5,11.602 20.342,11.221 20.061,10.939C19.779,10.658 19.398,10.5 19,10.5H16Z",
    id: "path_0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormulaIcon5);
export default __webpack_public_path__ + "static/media/formula_icon5.3a7ed0cd961eaf6e153d8ca7129c611e.svg";
export { ForwardRef as ReactComponent };